import storeActions from './actions'
import { reactive } from 'vue'

const initialState = {
    configId: undefined,
    sessionId: undefined,
    excludedCategories: [],
    classificationId: 97,
    parentSelector: '[data-cxco-faq]',
    title: 'Veel gestelde vragen',
    search: {
        show: false,
        placeholder: 'Search Faqs',
        searchButton: 'Search'
    },
    maxBreakpoints: 3,
    feedback: {
        show: false,
        showFeedbackNotify: undefined,
        intro: 'Was this article helpful?',
        positive: 'yes',
        negative: 'no',
        thanks: 'thanks for leaving feedback.',
        submit: 'submit feedback',
        placeholder: 'What can we improve?'
    },
    categories: [],
    headings: [],
    faqs: [],
    selectedCategories: [-1],
    feedbackQueue: [],
    nodesInView: 1,
    width: [],
    icons: {},
    depth: 1,
    searchResults: [],
    searchAnswer: [],
    searchAnswerLoadingText: 'Loading...',
    searchingText: 'Searching...',
    noResultsText: 'No FAQs found',
    style: ''
}

const state = reactive(initialState)
const actions = storeActions(state)

export default { initialState, state, actions }
